import { graphql } from 'react-relay';

// Dev note: If this is changed you likely need to update `PageStatusQuery` in query-preloaders-common
export const PageStatusQuery = graphql`
	query PageStatusQuery($contentId: ID!) {
		content(id: $contentId, status: ["archived", "current"]) {
			nodes {
				id
				status
			}
		}
	}
`;
